export default "__VITE_ASSET__CMZ3W52P__"